'use client';

import { useCallback } from 'react';
import { useTranslations, useLocale } from 'next-intl';
import { PublicLayout } from '@/components/public-layout';
import { normalizeLocale } from '@/i18n/config';
import { MarketingLandingPage, type MarketingLandingT } from '@/components/marketing-landing-page';

export default function LocalizedMarketingLanding() {
  const tIntl = useTranslations();
  const locale = useLocale();
  const normalizedLocale = normalizeLocale(locale);

  const t = useCallback<MarketingLandingT>(
    (key, params) => {
      if (params && Object.keys(params).length > 0) {
        return tIntl(key, params as Record<string, string | number | Date>);
      }
      return tIntl(key);
    },
    [tIntl],
  );

  return (
    <PublicLayout>
      <MarketingLandingPage t={t} normalizedLocale={normalizedLocale} />
    </PublicLayout>
  );
}
